import { render, staticRenderFns } from "./rebookings.vue?vue&type=template&id=0054cfc4&scoped=true"
import script from "./rebookings.vue?vue&type=script&lang=js"
export * from "./rebookings.vue?vue&type=script&lang=js"
import style0 from "./rebookings.vue?vue&type=style&index=0&id=0054cfc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0054cfc4",
  null
  
)

export default component.exports